// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"NoResults_wrapper__1fO6e","image":"NoResults_image__3f1KB"};